import { render, staticRenderFns } from "./inspectionList.vue?vue&type=template&id=19ef4516&scoped=true&"
import script from "./inspectionList.vue?vue&type=script&lang=js&"
export * from "./inspectionList.vue?vue&type=script&lang=js&"
import style0 from "./inspectionList.vue?vue&type=style&index=0&id=19ef4516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef4516",
  null
  
)

export default component.exports